// extracted by mini-css-extract-plugin
export default {"HeaderSection":"HeaderSection_HeaderSection__HCHZa","TopPanel":"HeaderSection_TopPanel__wklV6"};